/// <amd-module name="Build/Common/Commands/importdefinition/Command" />
import * as React from "react";

import { IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { LegacyComponent } from "VSS/Legacy/Legacy";

class ImportDefinition extends VssComponent<IVssComponentProperties, {}> {
    public static componentType = "ciImportDefinitionComponent";

    constructor(props: IVssComponentProperties) {
        super(props);
    }

    public render() {
        return (
            <LegacyComponent
                modules={["Build/Scripts/Components/ImportDefinitionDialog"]}
                wrappedType="ci-import-dialog"
            />
        );
    }
}

VssComponent.register(ImportDefinition.componentType, ImportDefinition);